import * as Types from '../constants/Types';

export const getListRates = (filters) => ({ type: Types.RATE_LIST_ACTION, filters });
export const setListRates = (data) => ({ type: Types.RATE_LIST_SUCCESS, dataList: data.dataList, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });
export const getRate = (id) => ({ type: Types.RATE_DETAIL_ACTION, id });
export const setRate = (rate) => ({ type: Types.RATE_DETAIL_SUCCESS, rate: rate});
export const saveRate = (params) => ({ type: Types.RATE_SAVE_ACTION, rate: params.rate, props: params.props});
export const saveRateSuccess = (rate) => ({ type: Types.RATE_SAVE_SUCCESS, rate: rate});

export const createRateTranslate = (rate, language, targetLanguages) => ({type: Types.RATE_CREATE_TRANSLATE_ACTION, rate, language, targetLanguages});
export const updateRateTranslate = (rate, language, targetLanguages) => ({type: Types.RATE_UPDATE_TRANSLATE_ACTION, rate, language, targetLanguages});
export const deleteRateTranslate = (rate, refreshParams) => ({type: Types.RATE_DELETE_TRANSLATE_ACTION, rate, refreshParams});


export const sortRate = (rates, filters) => ({type: Types.RATE_SORT_ACTION, rates, filters})
export const syncRatesAllHotels = () =>  ({ type: Types.RATE_SYNC_ALL_HOTELS_ACTION });

export const syncRates = (hotelId, rateCodes = [] , isRefresh = false) =>  ({ type: Types.RATE_SYNC_RATES_ACTION, hotelId, rateCodes, isRefresh });
export const setSyncRates = (rates) => ({ type: Types.RATE_SYNC_RATES_SUCCESS, ...rates });
export const syncRatesSuccess = (hotelId) => ({ type: Types.RATE_SYNC_RATES_SUCCESS, hotelId });

export const getListRatesByHotels = (filters) => ({ type: Types.RATE_LIST_BY_HOTELS_ACTION, filters });
export const setListRatesByHotels = (data) => ({ type: Types.RATE_LIST_BY_HOTELS_SUCCESS, dataListRateByHotels: data });

export const updateCancelPolicys = (cancelPolicys, id) => ({type: Types.CANCEL_POLICY_UPDATE_ACTION, cancelPolicys, id});
export const syncCancelPolicys = (cancelPolicys, id) => ({type: Types.CANCEL_POLICY_SYNC_ACTION, cancelPolicys, id});

export const usageStatus = (rates, filters) => ({type: Types.RATE_USAGE_STATUS_ACTION, rates, filters});
export const updateRateActive = (obj) => ({type: Types.RATE_UPDATE_ACTIVE_ACTION, obj});

export const syncRateLanguage = (obj) => ({type: Types.SYNC_RATE_LANGUAGE_ACTION, obj});
export const setSyncRateLanguage = (rates) => ({ type: Types.SYNC_RATE_LANGUAGE_SUCCESS, ...rates });

export const updateRateExtend = (obj) => ({ type: Types.RATE_UPDATE_EXTEND_ACTION, obj });

export const createRateBeachVilla = (id, rate) => ({ type: Types.RATE_BEACH_VILLA_CREATE_ACTION, id, rate })

export const getPriceConfigBeachVilla = (filters) => ({ type: Types.PRICE_CONFIG_LIST_ACTION, filters });
export const setPriceConfigBeachVilla = (data) => ({ type: Types.PRICE_CONFIG_LIST_SUCCESS, dataList: data.result, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });

export const createPriceConfigBeachVilla = (data) => ({ type: Types.PRICE_CONFIG_BEACH_VILLA_CREATE_ACTION, data })
export const updatePriceConfigBeachVilla = (data) => ({ type: Types.PRICE_CONFIG_BEACH_VILLA_UPDATE_ACTION, data })
